import { makeStyles, createStyles } from '@mui/styles';
import {
  ccfConversationsActions,
  getSelectedAgent,
  getSelectedAgentType,
} from '../+state/ccf-conversations.slice';
import { useDispatch, useSelector } from 'react-redux';
import {
  CONVERSATION_CONTAINER_FOOTER_HEIGHT,
  CONVERSATION_CONTAINER_REPLYBOX_HEIGHT,
} from '../utils/conversations.utils';
import {
  CcfBox,
  CcfButton,
  CcfTextField,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import classes from './conversations-reply-app-container.module.scss';
import {
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatUnderlined,
  Send,
} from '@mui/icons-material';
import { useState } from 'react';
import { useMsal } from '@azure/msal-react';

const useStyles = makeStyles(() =>
  createStyles({
    chatContainer: {
      paddingInline: 8,
      height: 'auto',
      marginTop: 4,
      marginBottom: 8,
    },
    footerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingInline: 8,
      // marginTop: 4,
      marginBottom: 4,
      height: 'auto',
    },
    customButton: {
      minWidth: 40,
      marginRight: '8px',
    },
  })
);

/**
 * Component to be used for conversation reply
 * @example <ConversationsReplyContainer />
 * @returns
 */
export const ConversationsReplyAppContainer = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const { accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const selectedAgent = useSelector(getSelectedAgent);
  const selectedAgentType = useSelector(getSelectedAgentType);
  const [message, setMessage] = useState('');
  const { updateSelectedAgent, updateAgentGroups, updateAgents } =
    ccfConversationsActions;

  /**
   * Handler for sending a message.
   * @example sendMessageHandler()
   */
  const sendMessageHandler = () => {
    const newMessage = {
      name: loginCredentialsFromSSO,
      status: 'available',
      text: message,
      timestamp: Date.now(),
      color: '#EE67AF',
    };
    const updatedSelectedAgent = {
      ...selectedAgent,
      messages: [...selectedAgent.messages, newMessage],
    };

    dispatch(
      updateSelectedAgent({
        agent: updatedSelectedAgent,
        type: selectedAgentType,
      })
    ); //update selected agent in store

    const updateAction =
      selectedAgentType === 'group' ? updateAgentGroups : updateAgents;
    dispatch(updateAction({ agent: updatedSelectedAgent, type: 'update' })); //update agents and agengroups in store
    setMessage(''); //clear the message box
  };

  return (
    <>
      <section className={styles.chatContainer}>
        <CcfTextField
          id={`${selectedAgent?.name}-textbox`}
          variant="outlined"
          placeholder={`Chat with ${selectedAgent?.name}`}
          fullWidth
          size="small"
          multiline
          InputProps={{
            rows: 3,
          }}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          maxRows={3}
        />
      </section>
      <footer className={styles.footerContainer}>
        <CcfBox className={classes.leftBtnGroup}>
          <CcfButton
            color="secondary"
            size="small"
            classes={{ root: styles.customButton }}
          >
            <FormatBold />
          </CcfButton>
          <CcfButton
            color="secondary"
            size="small"
            classes={{ root: styles.customButton }}
          >
            <FormatUnderlined />
          </CcfButton>
          <CcfButton
            color="secondary"
            size="small"
            classes={{ root: styles.customButton }}
          >
            <FormatItalic />
          </CcfButton>
          <CcfButton
            color="secondary"
            size="small"
            classes={{ root: styles.customButton }}
          >
            <FormatListBulleted />
          </CcfButton>
        </CcfBox>
        <CcfButton
          className={`${classes.sendBtn} ${
            message ? '' : classes.disabledSendBtn
          }`}
          onClick={sendMessageHandler}
        >
          <CcfTypography className={classes.sendBtnText}>Send</CcfTypography>
          <Send style={{ fill: message ? 'white' : '#0000001a' }} />
        </CcfButton>
      </footer>
    </>
  );
};
